export const TRANSFER_ORDER = 'TRANSFER_ORDER'
export const TRANSFER_ORDER_FAILED = 'TRANSFER_ORDER_FAILED'

export const transferOrder = (payload = {}) => ({
  type: TRANSFER_ORDER,
  payload,
})

export const transferOrderFailed = (payload = {}) => ({
  type: TRANSFER_ORDER_FAILED,
  payload,
})
